import manifest from '../../public/admin-navigation.json';
import { resolveSidebarIcon } from './sidebar-icons';

export function adminNavigation(homeUrl?: string) {
  return manifest.groups.map(group => ({
    label: group.label,
    items: group.items.filter(item => item.app === 'courses' || !!homeUrl).map(item => ({
      name: item.label,
      href: item.app === 'courses' ? item.path : `${homeUrl?.replace(/\/$/, '')}${item.path}`,
      icon: resolveSidebarIcon(item.icon),
      exact: 'exact' in item && item.exact === true,
    })),
  }));
}
